import React, { useCallback } from 'react';
import { Typography, List } from 'antd';
import BatchUploader from '../../../common/BatchUploader';
import { Batch } from '../../../types';
import { FormItemLabel, ModalSubTitle } from '../../../components/text/Titles';

const { Text } = Typography;

type Props = {
  setBatchUploadReports: (batches: Batch[]) => any;
  batchUploadReports: Batch[];
  getPresignedUrl?: string;
  getPresignedParams?: object;
};

export const UploadFilesStep = (props: Props) => {
  const { setBatchUploadReports, batchUploadReports, getPresignedParams, getPresignedUrl } = props;

  const onBatchUploaded = useCallback(response => setBatchUploadReports([...batchUploadReports, response]), [
    setBatchUploadReports,
    batchUploadReports,
  ]);

  return (
    <>
      <FormItemLabel>Drag & drop the documents you would like to process using this Flow.</FormItemLabel>
      <div style={{ marginTop: '16px', marginBottom: '16px' }}>
        <BatchUploader
          modelId={null}
          multiple={true}
          noInference={true}
          onBatchUploaded={onBatchUploaded}
          getPresignedUrl={getPresignedUrl}
          getPresignedParams={getPresignedParams}
        />
      </div>
      <ModalSubTitle>Uploaded documents</ModalSubTitle>
      <div>
        {batchUploadReports && batchUploadReports.length > 0 ? (
          <List
            dataSource={batchUploadReports.map(it => it.files).flat()}
            renderItem={item => <List.Item>{item.fileName}</List.Item>}
          />
        ) : (
          <Text className={'descriptive-title'} style={{ fontSize: '14px' }}>
            No documents yet.
          </Text>
        )}
      </div>
    </>
  );
};
